import React from 'react';
import { Filter } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export default function FilterBar({ filterDiff, setFilterDiff, filterYear, setFilterYear, years }) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-1 text-[11px] uppercase tracking-[0.16em] text-slate-500">
        <Filter className="w-3.5 h-3.5" /> Filters
      </div>
      <Select value={filterDiff} onValueChange={setFilterDiff}>
        <SelectTrigger className="w-[140px] h-9 text-[13px] bg-white/[0.03] border-white/10 text-slate-200 hover:bg-white/[0.05]">
          <SelectValue placeholder="Difficulty" />
        </SelectTrigger>
        <SelectContent className="bg-[#0b0f1a] border-white/10 text-slate-200">
          <SelectItem value="all">All difficulty</SelectItem>
          <SelectItem value="Easy">Easy</SelectItem>
          <SelectItem value="Medium">Medium</SelectItem>
          <SelectItem value="Hard">Hard</SelectItem>
        </SelectContent>
      </Select>
      <Select value={filterYear} onValueChange={setFilterYear}>
        <SelectTrigger className="w-[120px] h-9 text-[13px] bg-white/[0.03] border-white/10 text-slate-200 hover:bg-white/[0.05]">
          <SelectValue placeholder="Year" />
        </SelectTrigger>
        <SelectContent className="bg-[#0b0f1a] border-white/10 text-slate-200">
          <SelectItem value="all">All years</SelectItem>
          {years.map((y) => <SelectItem key={y} value={y}>{y}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
